import { render, staticRenderFns } from "./TileActions.vue?vue&type=template&id=2a58f324&scoped=true"
import script from "./TileActions.vue?vue&type=script&lang=js"
export * from "./TileActions.vue?vue&type=script&lang=js"
import style0 from "./TileActions.vue?vue&type=style&index=0&id=2a58f324&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a58f324",
  null
  
)

export default component.exports